import PeiApi from "../service";
import resourcesService from "@/services/resources.js";
import academicYearService from "@/services/academicyear";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";

export default {
  async loadTabsData({ commit, dispatch, getters }, payload) {
    commit("setInitialState", payload);
    dispatch("fetchResources");
    await dispatch("fetchSysParameters");
    await dispatch("fetchNecessityGrades");
    await dispatch("fetchGoalsTabInfo");
    await dispatch("fetchSubAreas");
    dispatch("fetchNecessityTabInfo", getters.defaultGrade?.id);
    dispatch("fetchStrengthNecessityTabInfo", getters.defaultGrade?.id);
    dispatch("fetchStrengthTabInfo", getters.defaultGrade?.id);
    dispatch("fetchProcedureTabInfo");
  },
  async fetchSysParameters({ commit, state }) {
    const { data: peiParams } = await getSysparameterByNames({
      academicYearId: state.base.academicYearId,
      parameterNames: ["PEIStrengthsAndNeedsCatalog"]
    });

    const PEIStrengthsAndNeedsCatalog = peiParams.find(
      x => x.name == "PEIStrengthsAndNeedsCatalog"
    );

    const {
      data: current
    } = await academicYearService.getCurrentAcademicYear();
    const { data: yearParams } = await getSysparameterByNames({
      academicYearId: current.id,
      parameterNames: [
        "ShowSummaryResultInPei",
        "ShowCompensatoryServicesInPei"
      ]
    });

    const ShowSummaryResultInPei = yearParams.find(
      x => x.name == "ShowSummaryResultInPei"
    );
    const ShowCompensatoryServicesInPei = yearParams.find(
      x => x.name == "ShowCompensatoryServicesInPei"
    );

    const sysParameters = {
      PEIStrengthsAndNeedsCatalog: PEIStrengthsAndNeedsCatalog,
      ShowSummaryResultInPei: ShowSummaryResultInPei,
      ShowCompensatoryServicesInPei: ShowCompensatoryServicesInPei
    };
    commit("setSysParameters", sysParameters);
  },
  async fetchResources({ commit }) {
    const resources = await resourcesService.LoadValidationMessages([
      "R03200110",
      "R03200109",
      "R03200108",
      "R900006",
      "R900007",
      "R900008",
      "R900009",
      "R900010",
      "R900011",
      "R03200129",
      "R90013",
      "R900014",
      "R900015",
      "R90016",
      "R90017"
    ]);

    commit("setResources", resources);
  },
  async fetchNecessityGrades({ commit, state }) {
    const payload = {
      sie: state.base.studentSieId,
      academicYearId: state.base.academicYearId
    };
    const { data } = await PeiApi.GetGrades(payload);
    commit("setGradeCatalogue", data);
  },
  async fetchNecessityTabInfo({ commit, state, getters }, paramGradeId) {
    const gradeId = getters.showNecessitiesCatalogue ? paramGradeId : null;
    const { data } = await PeiApi.GetNecessityInfo(
      state.base.programServiceAreaId,
      state.selectedArea.id,
      gradeId,
      state.base.academicYearId
    );

    commit("setNecessities", data.selectedNecessities);
    commit("setNecessityCatalogue", data.availableNecessities);
  },
  async fetchStrengthNecessityTabInfo(
    { commit, state, getters },
    paramGradeId
  ) {
    const gradeId = getters.showNecessitiesCatalogue ? paramGradeId : null;
    const { data } = await PeiApi.GetSkillsInfo(
      state.base.programServiceAreaId,
      state.selectedArea.id,
      gradeId,
      state.base.academicYearId
    );

    commit("setStrengthNecessitySelection", data.selectedStrengthNecessities);
    commit("setSkillCatalogue", data.availableNecessities);
  },
  async fetchGoalsTabInfo({ commit, state }) {
    const goalsResponse = await PeiApi.GetGoalsInfo(
      state.base.programServiceAreaId
    );
    commit("setGoals", goalsResponse.data);

    const adequacyResponse = await PeiApi.GetAdequacies();
    commit("setAdequacyCatalogue", adequacyResponse.data);

    const cataloguesResponse = await PeiApi.GetGoalCatalogues();
    commit("setTermsCatalogue", cataloguesResponse.data.terms);
    commit("setSuitabilitiesCatalogue", cataloguesResponse.data.suitabilities);
    commit("setInstrumentsCatalogue", cataloguesResponse.data.instruments);
  },
  async fetchProcedureTabInfo({ commit, state }) {
    const { data } = await PeiApi.GetProcedureInfo(
      state.base.programServiceAreaId
    );
    commit("setAvailableProceduresCatalogue", data.availableProcedures);
    commit("setProceduresSelection", data.selectedProcedures);
  },
  async fetchStrengthTabInfo({ commit, state, getters }, paramGradeId) {
    const gradeId = getters.showNecessitiesCatalogue ? paramGradeId : null;
    const { data } = await PeiApi.GetStrengthInfo(
      state.base.programServiceAreaId,
      state.selectedArea.id,
      gradeId,
      state.base.academicYearId
    );

    commit("setStrengthsSelection", data.selectedStrengths);
    commit("setStrengthsCatalogue", data.availableStrengths);
  },
  async fetchSubAreas({ commit, state }) {
    const { data } = await PeiApi.GetSubAreas(
      state.base.programServiceAreaId,
      state.selectedArea.id
    );

    commit("setSubAreaSelection", data.selectedSubareas);
    commit("setSubAreasCatalogue", data.availableSubareas);
  }
};
